
export const ENV = 'production'

export const HOST = ENV === "development"
    ? "https://api-crm.staypinc.com"
    : "https://api-crm.pinc.co.in";

export const API = '/cpl-api/'

export const s3_bucket_prod_url = 'http://pinc-prod-public-bucket.s3-ap-south-1.amazonaws.com/'
export const s3_bucket_uat_url = 'http://pinc-uat-public-bucket.s3-ap-south-1.amazonaws.com/'

export const UAT = 'https://www.staypinc.com/'
export const PROD = 'https://www.pincinsurance.com/'


export const SUB_DIRECTORY = '';

// Login Routes
export const LOGIN = `${HOST}${API}login`
export const FORGOT_PASSWORD = `${HOST}${API}forgot-password`
export const NEW_PASSWORD = `${HOST}${API}reset-password`
export const VERIFY_TOKEN = `${HOST}${API}validate-token`


//Dashboard
export const GET_POLICY_DASHBOARD = `${HOST}${API}getPolicy`
export const GET_POLICY_INACTIVE = `${HOST}${API}getPolicy`
export const DOWNLOAD_POLICY = `${HOST}${API}download-policy-doc`
export const NON_HEALTH_CLAIM = `${HOST}${API}get-non-health-claim`

//policy Wallet
export const POLICY_WALLET = `${HOST}${API}getLeadPolicy`
export const ADD_POLICY_WALLET = `${HOST}${API}add-lead-policy`
export const POLICY_WALLET_DELETE = `${HOST}${API}delete-lead-policy`

//claim
export const GET_CLAIM = `${HOST}${API}getClaim`
export const INTIMATE_CLAIM = `${HOST}/corporate/claim-intimate`
export const DOWNLOAD_CLAIM_DOC = `${HOST}${API}download-claim-doc`
export const UPLOAD_CLAIM_DOC = `${HOST}/corporate/claim-upload`



//my profile
export const ALL_CONTACT_PERSON = `${HOST}${API}all-contact-person`
export const PROFILE = `${HOST}${API}all-contact-person`
export const UPLOAD_PROFILE_IMAGE = `${HOST}${API}all-contact-person`
export const PROFILE_EDIT = `${HOST}/corporate/client-update`
export const KYC_DOCUMENTS = `${HOST}${API}all-contact-person`
export const UPLOAD_KYC_DOCUMENTS = `${HOST}${API}upload-kyc-document`
export const KYC_DOCUMENTS_DELETE = `${HOST}${API}delete-kyc-document`
export const CLIENT_LIST = `${HOST}${API}client-list`
export const POLICY_COMPANY_LIST = `${HOST}${API}policy-client-list`
export const CLIENT_DETAILS = `${HOST}${API}client-detail`
export const KYC_DOCUMENTS_DOWNLOAD = `${HOST}${API}download-kyc-document`
export const CHANGE_PASSWORD = `${HOST}${API}change-password`


//common API
export const CITY_DROPDOWN = `${HOST}${API}`
export const DROPDOWN = `${HOST}${API}static-data/all`
export const SUB_NEWSLETTER = `${HOST}${API}subscribe-newsletter`

//Appointments API
export const GET_APPOINTMENTS = `${HOST}${API}appointments`

//Add feedback
export const ADD_FEEDBACK = `${HOST}${API}add-feedback`
export const INFORMATION_CARD = `${HOST}${API}static-data/information-card`

//Add feedback
export const ADD_ENQUIRY = `${HOST}${API}add-enquiry`

//reviews
export const REVIEWS = `${HOST}${API}static-data/reviews`

//notifications
export const LATEST_NOTIFICATION = `${HOST}${API}notification/latest`
export const GET_ALL_NOTIFICATION = `${HOST}${API}notification/all`
export const MARK_ALL_NOTIFICATION_READ = `${HOST}${API}notification/read`
export const NOTIFICATION_DELETE = `${HOST}${API}notification/delete`
export const LOGOUT = `${HOST}${API}logout`

// client verification
export const CLIENT_VERIFICATION_UPDATE = `${HOST}${API}update-client`
